var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGestioneer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1596.45 300.45",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7f55ff;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 129,
    x2: 1545.73,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c86dfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8f5bfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4949ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01b2fe"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1498.76,95.2c24.96-21.02,60.93-42.14,97.69-32.89l-9.33,42.72s-45.79-2.83-61.18,31.34l-27.94-8.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m805.5,60.55c-46.12,0-83.5,37.38-83.5,83.5s37.38,83.5,83.5,83.5,83.5-37.38,83.5-83.5-37.38-83.5-83.5-83.5Zm0,119c-19.61,0-35.5-15.89-35.5-35.5s15.89-35.5,35.5-35.5,35.5,15.89,35.5,35.5-15.89,35.5-35.5,35.5Zm-448.58-22.13c-6.4,39.76-40.86,70.13-82.42,70.13-46.12,0-83.5-37.38-83.5-83.5s37.38-83.5,83.5-83.5c39.77,0,73.02,27.81,81.43,65.04l-45.93,18.96-1.55-10.89c-4.44-14.54-17.96-25.11-33.95-25.11-19.61,0-35.5,15.89-35.5,35.5s15.89,35.5,35.5,35.5c17.64,0,32.27-12.87,35.03-29.74l47.39,7.61Zm919,0c-6.4,39.76-40.86,70.13-82.42,70.13-46.12,0-83.5-37.38-83.5-83.5s37.38-83.5,83.5-83.5c39.77,0,73.02,27.81,81.43,65.04l-45.93,18.96-1.55-10.89c-4.44-14.54-17.96-25.11-33.95-25.11-19.61,0-35.5,15.89-35.5,35.5s15.89,35.5,35.5,35.5c17.64,0,32.27-12.87,35.03-29.74l47.39,7.61Zm194,0c-6.4,39.76-40.86,70.13-82.42,70.13-46.12,0-83.5-37.38-83.5-83.5s37.38-83.5,83.5-83.5c39.77,0,73.02,27.81,81.43,65.04l-45.93,18.96-1.55-10.89c-4.44-14.54-17.96-25.11-33.95-25.11-19.61,0-35.5,15.89-35.5,35.5s15.89,35.5,35.5,35.5c17.64,0,32.27-12.87,35.03-29.74l47.39,7.61Zm75.81,70.57h-48V61h48v167Zm-949.5,3c-36.21,0-62.5-27.12-62.5-64.47V27h48v139.53c0,10.93,4.88,16.47,14.5,16.47,3.23,0,6.31-.59,9.16-1.76l18.21,44.41c-8.66,3.55-17.86,5.35-27.37,5.35Zm104.5-3h-48V71h48v157Zm377,0h-48v-81.92c0-20.44-15.7-37.08-35-37.08s-35,16.63-35,37.08v81.92h-48v-81.92c0-46.91,37.23-85.08,83-85.08s83,38.17,83,85.08v81.92ZM83.5,60.55C37.38,60.55,0,97.94,0,144.05s37.38,83.5,83.5,83.5,83.5-37.38,83.5-83.5-37.38-83.5-83.5-83.5Zm0,119c-19.61,0-35.5-15.89-35.5-35.5s15.89-35.5,35.5-35.5,35.5,15.89,35.5,35.5-15.89,35.5-35.5,35.5Zm417.92-2.89c1.09,60.71-92.33,63.61-130.15,27.13l16.69-29.6c15.32,13.52,70.19,33.06,74.47,5.23,0-8.9-6.43-12.17-32.42-18.78-75.66-13.74-61.62-102.25,10.52-100.06,23.61,0,43.56,11.21,57.34,21.85l-17.61,28.5c-14.4-11.54-57.92-27.23-61.68-2.48,0,8.89,8.14,10.97,30.6,17.05,40.87,11.05,52.24,25.11,52.24,51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m355.88,125.4l-45.89,19.2-60.01,25.11-45.89,19.2c-5.06-7.92-8.82-16.76-10.97-26.21l45.89-19.2,60.01-25.11,45.89-19.2c5.06,7.92,8.82,16.76,10.97,26.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1274.88,125.4l-45.89,19.2-60.01,25.11-45.89,19.2c-5.06-7.92-8.82-16.76-10.97-26.21l45.89-19.2,60.01-25.11,45.89-19.2c5.06,7.92,8.82,16.76,10.97,26.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1468.88,125.4l-45.89,19.2-60.01,25.11-45.89,19.2c-5.06-7.92-8.82-16.76-10.97-26.21l45.89-19.2,60.01-25.11,45.89-19.2c5.06,7.92,8.82,16.76,10.97,26.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 533.73,
    y: 74,
    width: 86,
    height: 33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 652.73,
    y: 0,
    width: 48,
    height: 48,
    rx: 24,
    ry: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m124,250.55l20,42h0c-26.37,10.59-94.62,10.47-121,0h0l20-42,.08-.03c26.38,7.85,54.47,7.85,80.85,0l.08.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.73,
    y: 61,
    width: 84,
    height: 48
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGestioneer);
export default __webpack_public_path__ + "static/media/logo-gestioneer.763b74fd45ed021300a9724217ba8eb0.svg";
export { ForwardRef as ReactComponent };